import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'fileSize'})
export class ConvertFileSizePipe implements PipeTransform {
  constructor() {
  }

  transform(value: any, type: any): any {

    let size = 0;

    if (value && type) {
          switch (type) {
            case  "Mb" : size = (value / 1024 / 1024);
            break;
            case "Kb" : size = (value / 1000);
            break;
          }
    }
    return size.toFixed(0);
  }
}

